<card *ngIf="!(responsiveService.mdBelow | async)">
    <div card-body class="invoice-table">
        <lsq-data-table
            [hasHeader]="true"
            [dataSource]="listPendingGroupsDataSource"
            [isPaginated]="true"
            [layoutFixed]="true"
            [trackBy]="trackByPendingKeys"
            [appearance]="tableAppearance.Default"
            [getRowClassName]="getCreditMemosRowClassNameBound"
            [columnVisibilities]="{
                Revoke:
                    (canRevokeFeatureFlag$ | async) &&
                    (buyerAccountSharedService.canRevokeInvoices$ | async),
                businessUnitName: isFinancingAccountPortalUser
            }"
        >
            <lsq-column
                [column]="{
                    key: 'isGroup',
                    width: '4.5rem',
                    sortable: false
                }"
            >
                <ng-template [custom-cell] let-row="row" let-index="index">
                    <div [style.padding-top]="0" [style.padding-bottom]="0">
                        <ng-container *ngIf="row.isGroup">
                            <div
                                class="invoice-group-expand-button"
                                [class.disabled]="pendingGroupTogglesAreDisabled"
                                [attr.tabindex]="0"
                                (click)="handlePendingGroupToggleClick(row)"
                            >
                                <lsq-icon
                                    [type]="
                                        expandedGroupPendingKeys.has(row.groupKey)
                                            ? icons.ChevronDown
                                            : icons.ChevronRight
                                    "
                                    [color]="color.Black"
                                >
                                </lsq-icon>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="row.itemKey">
                            {{
                                row | getOffsetIndexOfSiblingRow: index:'groupKey':'isGroup' | async
                            }}
                        </ng-container>
                    </div>
                </ng-template>
            </lsq-column>
            <lsq-column
                [column]="{
                    header: supplierNameI18n,
                    key: 'sellerName',
                    truncateTextCss: true,
                    width: '14%',
                    sortable: true
                }"
            >
                <ng-template [custom-cell] let-row="row">
                    <a
                        class="p not-bold supplier-name"
                        (click)="goSupplierDetails(row.sellerKey)"
                        queryParamsHandling="preserve"
                    >
                        <lsq-truncate [value]="row.sellerName" [maxLength]="20"></lsq-truncate>
                    </a>
                </ng-template>
            </lsq-column>

            <lsq-column
                [column]="{
                    header: businessUnitI18n,
                    key: 'businessUnitName',
                    truncateTextCss: true,
                    width: '16%',
                    sortable: true
                }"
            >
            </lsq-column>

            <lsq-column
                [column]="{
                    header: invoiceNumberI18n,
                    key: 'groupId',
                    width: '20%',
                    truncateAfter: invoiceNumberTruncateAfter$ | async,
                    reverseTruncate: true,
                    sortable: true,
                    onCellClick: goToPendingCredMemoDetailBound,
                    isClickableFunction: isInvoiceClickableBound
                }"
            >
            </lsq-column>

            <lsq-date-column
                [displayNullIfFieldIsTrue]="'isGroup'"
                [isShortDate]="true"
                [column]="{
                    header: invoiceDateI18n,
                    key: 'invoiceDate',
                    width: '11rem',
                    sortable: false
                }"
            >
            </lsq-date-column>

            <lsq-date-column
                [displayNullIfFieldIsTrue]="'isGroup'"
                [isShortDate]="true"
                [column]="{
                    header: dueDateI18n,
                    key: 'dueDate',
                    width: '11rem',
                    sortable: false
                }"
            >
            </lsq-date-column>

            <lsq-currency-column
                [column]="{
                    header: invoiceAmountI18n,
                    key: 'total',
                    width: '15%',
                    sortable: true
                }"
            >
            </lsq-currency-column>

            <lsq-spacer-column width="5%"></lsq-spacer-column>

            <lsq-column
                [column]="{
                    header: invoiceStatusI18n,
                    key: 'fundingStatus',
                    width: '11rem',
                    sortable: false
                }"
            >
                <ng-template [custom-cell] let-row="row">
                    <ng-container
                        *ngIf="
                            row.total?.cents < 0 && !row.isGroup && row.fundingStatus != 'REVOKED';
                            else regularStatus
                        "
                    >
                        <status-pill
                            [status]="creditMemoStatus"
                            [color]="statusColor.CREDIT_MEMO"
                            [displayValueMap]="invoiceFundingStatusDisplay"
                        >
                        </status-pill>
                    </ng-container>
                    <ng-template #regularStatus>
                        <status-pill
                            [status]="row.status || ineligibleStatus"
                            [color]="statusColor[row.status || ineligibleStatus]"
                            [displayValueMap]="invoiceFundingStatusDisplay"
                        >
                        </status-pill>
                    </ng-template>
                </ng-template>
            </lsq-column>

            <lsq-button-column
                [column]="{
                    header: revokeHeaderI18n,
                    key: 'Revoke',
                    width: '7rem'
                }"
                (buttonClick)="handleRevokeClick($event)"
                [hideButton]="revokeButtonIsHiddenBound"
                [icon]="icons.CloseSmall"
            >
            </lsq-button-column>
        </lsq-data-table>
    </div>
</card>
<div *ngIf="responsiveService.mdBelow | async">
    <lsq-data-table-mobile
        [dataSource]="listPendingGroupsDataSource"
        [isPaginated]="true"
        [cardsAreClickable]="true"
        [cardsAreExpandable]="true"
    >
        <ng-template #mobileCardHeader let-row="row">
            <div class="invoices-header-mobile">
                <div class="mtc-header-content-left">
                    <div class="mtc-header-title">
                        {{ row.sellerName }}
                    </div>
                    <div class="mtc-header-sub-title">
                        <span *ngIf="!isInvoiceClickableBound(row)">{{ row.groupId }}</span>
                        <a
                            *ngIf="isInvoiceClickableBound(row)"
                            (click)="goToPendingCredMemoDetailBound(row)"
                            >{{ row.groupId }}</a
                        >
                        <strong>{{ row.total | lsqCurrency }}</strong>
                    </div>
                </div>
                <div class="mtc-header-content-right">
                    <div class="mtc-header-status-text">
                        <status-pill
                            [status]="ineligibleStatus"
                            [color]="color.Red"
                            [displayValueMap]="invoiceFundingStatusDisplay"
                        >
                        </status-pill>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #mobileCardColumns let-row="row">
            <div class="card-item">
                <div class="card-item-label">
                    {{ invoiceDateI18n }}
                </div>
                <div class="card-item-value">
                    {{
                        row.invoiceDate && !row.isGroup
                            ? (row.invoiceDate | date: lsqShortDateFormat)
                            : nullValue
                    }}
                </div>
            </div>

            <div class="card-item">
                <div class="card-item-label">
                    {{ dueDateI18n }}
                </div>
                <div class="card-item-value">
                    {{ row.dueDate ? (row.dueDate | date: lsqShortDateFormat) : nullValue }}
                </div>
            </div>
        </ng-template>
        <ng-template *ngIf="canRevokeFeatureFlag$ | async" let-row="row">
            <div class="mtc-footer-link">
                <lsq-button
                    appearance="transparent"
                    (buttonClick)="handleRevokeClick(row)"
                    i18n="Table column button to revoke invoices"
                >
                    Revoke Invoice
                </lsq-button>
            </div>
        </ng-template>
    </lsq-data-table-mobile>
</div>
